import { getGetOrgMarketExtendCompositeDataListByFictitiousShopId } from "../../../request/ucenterapi/internal/business/getOrgMarketExtendCompositeDataListByFictitiousShopId/get.js";
import { reqGetOrgById } from "../../../request/ucenterapi/internal/org/getOrgById/get.js";
async function getUnifySelectInventoryOrg({
  param,
  getOrgMarketExtendInfo,
  getOrgNoById
}) {
  var _a, _b;
  const shopId = (_a = param.orderParam) == null ? void 0 : _a.shopId;
  const orgId = (_b = param.orderParam) == null ? void 0 : _b.orgId;
  const innerGetOrgMarketExtendInfo = getOrgMarketExtendInfo || getGetOrgMarketExtendCompositeDataListByFictitiousShopId;
  const innerGetOrgNoById = getOrgNoById || reqGetOrgById;
  if (shopId) {
    return await innerGetOrgMarketExtendInfo({
      fictitiousShopId: shopId,
      shopBrand: param.orderParam.checkBrand || param.searchOption.brand || "",
      shopCategory: param.orderParam.checkCategory || param.searchOption.category || ""
    });
  } else if (orgId) {
    return await innerGetOrgNoById({ orgId });
  }
  return void 0;
}
export { getUnifySelectInventoryOrg };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getOrg.js